import(/* webpackMode: "eager", webpackExports: ["TermsOfServiceContent"] */ "/app/src/features/pages/components/terms-of-service/TermsOfServiceContent.component.tsx");
